// Mock data and functions for frontend-only testing

export const mockTestimonials = [
  {
    id: 1,
    name: "Mohammed Al-Balushi",
    location: "Muscat, Oman",
    image: "https://i.pravatar.cc/150?img=33",
    rating: 5,
    text: {
      en: "Found an incredible deal to Istanbul for only 55 OMR! My family and I enjoyed a week exploring the Grand Bazaar and Bosphorus. NuzhaTrips made our dream vacation affordable!",
      ar: "وجدت عرضاً لا يصدق لإسطنبول بـ 55 ريال فقط! استمتعت أنا وعائلتي بأسبوع في استكشاف البازار الكبير والبوسفور. جعلت NuzhaTrips عطلة أحلامنا ميسورة التكلفة!"
    }
  },
  {
    id: 2,
    name: "Fatima Al-Hinai",
    location: "Salalah, Oman",
    image: "https://i.pravatar.cc/150?img=45",
    rating: 5,
    text: {
      en: "As a frequent traveler to Mumbai for business, I've saved over 500 OMR this year alone! The alerts are instant and accurate. Best travel service in Oman!",
      ar: "كمسافرة متكررة إلى مومباي للأعمال، وفرت أكثر من 500 ريال هذا العام وحده! التنبيهات فورية ودقيقة. أفضل خدمة سفر في عمان!"
    }
  },
  {
    id: 3,
    name: "Ahmed Al-Farsi",
    location: "Muscat, Oman",
    image: "https://i.pravatar.cc/150?img=12",
    rating: 5,
    text: {
      en: "Booked my family's tickets to London for only 240 OMR each! My kids are studying there, and NuzhaTrips helps me visit them frequently without breaking the bank. Highly recommended! 🎓✈️",
      ar: "حجزت تذاكر عائلتي إلى لندن بـ 240 ريال فقط للتذكرة! أطفالي يدرسون هناك، وتساعدني NuzhaTrips على زيارتهم بشكل متكرر دون إنفاق الكثير. أوصي بها بشدة! 🎓✈️"
    }
  },
  {
    id: 4,
    name: "Salim Al-Rawahi",
    location: "Nizwa, Oman",
    image: "https://i.pravatar.cc/150?img=51",
    rating: 5,
    text: {
      en: "Perfect for weekend getaways to Dubai! I fly there almost every month for shopping, and NuzhaTrips always finds me deals under 70 OMR. The WhatsApp support is super helpful! 🛍️",
      ar: "مثالية للرحلات القصيرة إلى دبي! أسافر هناك تقريباً كل شهر للتسوق، وتجد لي NuzhaTrips دائماً عروضاً بأقل من 70 ريال. دعم الواتساب مفيد جداً! 🛍️"
    }
  },
  {
    id: 5,
    name: "Maryam Al-Harthi",
    location: "Sohar, Oman",
    image: "https://i.pravatar.cc/150?img=49",
    rating: 5,
    text: {
      en: "My husband and I visited Cairo and saw the Pyramids for the first time! Total cost was only 180 OMR for both tickets. NuzhaTrips turned our 25th anniversary into a magical experience! 🔺❤️",
      ar: "زرت أنا وزوجي القاهرة ورأينا الأهرامات لأول مرة! التكلفة الإجمالية كانت 180 ريال فقط لكلا التذكرتين. حولت NuzhaTrips ذكرى زواجنا الـ25 إلى تجربة سحرية! 🔺❤️"
    }
  },
  {
    id: 6,
    name: "Khalid Al-Busaidi",
    location: "Muscat, Oman",
    image: "https://i.pravatar.cc/150?img=14",
    rating: 5,
    text: {
      en: "Bangkok trip with my friends for only 120 OMR! We explored temples, tried street food, and enjoyed the nightlife. NuzhaTrips made our bachelor party unforgettable within budget! 🎉🍜",
      ar: "رحلة بانكوك مع أصدقائي بـ 120 ريال فقط! استكشفنا المعابد، وجربنا طعام الشارع، واستمتعنا بالحياة الليلية. جعلت NuzhaTrips حفل العزوبية لا يُنسى ضمن الميزانية! 🎉🍜"
    }
  },
  {
    id: 7,
    name: "James Mitchell",
    location: "British Expat in Muscat",
    image: "https://i.pravatar.cc/150?img=68",
    rating: 5,
    text: {
      en: "As a British expat working in Oman, I travel back home frequently. NuzhaTrips saved me 800 OMR on my annual trips! Their alerts are spot-on, and I never miss a deal. Brilliant service!",
      ar: "كمغترب بريطاني يعمل في عمان، أسافر إلى وطني بشكل متكرر. وفرت لي NuzhaTrips 800 ريال على رحلاتي السنوية! تنبيهاتهم دقيقة، ولا أفوت أي صفقة أبداً. خدمة رائعة!"
    }
  },
  {
    id: 8,
    name: "Priya Sharma",
    location: "Indian Expat in Salalah",
    image: "https://i.pravatar.cc/150?img=47",
    rating: 5,
    text: {
      en: "Found amazing deals to visit my family in Delhi! Only 45 OMR during special promotions. NuzhaTrips keeps me connected with my loved ones without financial stress. Thank you!",
      ar: "وجدت عروضاً مذهلة لزيارة عائلتي في دلهي! 45 ريال فقط خلال العروض الخاصة. تبقيني NuzhaTrips على اتصال مع أحبائي دون ضغوط مالية. شكراً لكم!"
    }
  },
  {
    id: 9,
    name: "Sarah Johnson",
    location: "American Expat in Muscat",
    image: "https://i.pravatar.cc/150?img=44",
    rating: 5,
    text: {
      en: "Traveling Europe from Oman used to be expensive! NuzhaTrips helped me find flights to Paris for 195 OMR. Their service is professional, and the savings are real. Highly recommend to all expats!",
      ar: "كان السفر إلى أوروبا من عمان مكلفاً! ساعدتني NuzhaTrips في العثور على رحلات إلى باريس مقابل 195 ريال. خدمتهم احترافية، والتوفير حقيقي. أوصي بها بشدة لجميع المغتربين!"
    }
  },
  {
    id: 10,
    name: "Ali Al-Maskari",
    location: "Muscat, Oman",
    image: "https://i.pravatar.cc/150?img=52",
    rating: 5,
    text: {
      en: "Best investment for frequent travelers! I booked my honeymoon to Maldives for 180 OMR per person. The yearly plan pays for itself after just 2 trips. Absolutely worth it! 🏝️💕",
      ar: "أفضل استثمار للمسافرين المتكررين! حجزت شهر العسل في المالديف بـ 180 ريال للشخص. الخطة السنوية تدفع تكلفتها بعد رحلتين فقط. تستحق تماماً! 🏝️💕"
    }
  },
  {
    id: 11,
    name: "Emma Williams",
    location: "Australian Expat in Muscat",
    image: "https://i.pravatar.cc/150?img=42",
    rating: 5,
    text: {
      en: "Flying to Dubai for shopping sprees has become so affordable! I used to pay 150 OMR, now I get tickets for 60 OMR. NuzhaTrips is a game-changer for expats like me. Love it!",
      ar: "أصبح السفر إلى دبي للتسوق ميسور التكلفة جداً! كنت أدفع 150 ريال، الآن أحصل على تذاكر بـ 60 ريال. NuzhaTrips غيرت قواعد اللعبة للمغتربين مثلي. أحبها!"
    }
  },
  {
    id: 12,
    name: "Youssef Al-Balushi",
    location: "Muscat, Oman",
    image: "https://i.pravatar.cc/150?img=15",
    rating: 5,
    text: {
      en: "Took my elderly parents to Jeddah for Umrah at 95 OMR each! The savings allowed us to upgrade their accommodation. NuzhaTrips made our spiritual journey affordable. May Allah bless you! 🕋",
      ar: "أخذت والديّ المسنين إلى جدة للعمرة بـ 95 ريال للشخص! التوفير سمح لنا بترقية سكنهم. جعلت NuzhaTrips رحلتنا الروحانية ميسورة التكلفة. بارك الله فيكم! 🕋"
    }
  },
  {
    id: 13,
    name: "Michael O'Brien",
    location: "Irish Expat in Salalah",
    image: "https://i.pravatar.cc/150?img=69",
    rating: 5,
    text: {
      en: "Working in Oman and visiting family in Dublin is expensive. NuzhaTrips cut my travel costs by 40%! The customer service is responsive, and deals are legitimate. Best decision I made!",
      ar: "العمل في عمان وزيارة العائلة في دبلن مكلفة. خفضت NuzhaTrips تكاليف سفري بنسبة 40%! خدمة العملاء سريعة الاستجابة، والصفقات حقيقية. أفضل قرار اتخذته!"
    }
  },
  {
    id: 14,
    name: "Noor Al-Hinai",
    location: "Muscat, Oman",
    image: "https://i.pravatar.cc/150?img=48",
    rating: 5,
    text: {
      en: "Student budget-friendly! Flying to Malaysia for my semester abroad cost only 220 OMR. My parents were so relieved. NuzhaTrips made my education dreams possible! 🎓✈️",
      ar: "مناسب لميزانية الطلاب! السفر إلى ماليزيا للفصل الدراسي في الخارج كلف 220 ريال فقط. كان والداي مرتاحين جداً. جعلت NuzhaTrips أحلامي التعليمية ممكنة! 🎓✈️"
    }
  },
  {
    id: 15,
    name: "David Chen",
    location: "Singaporean Expat in Muscat",
    image: "https://i.pravatar.cc/150?img=67",
    rating: 5,
    text: {
      en: "Business trips to Singapore used to cost 280 OMR. Now I pay 190 OMR thanks to NuzhaTrips! My company is happy, and I get to see my family more often. Win-win situation!",
      ar: "كانت رحلات العمل إلى سنغافورة تكلف 280 ريال. الآن أدفع 190 ريال بفضل NuzhaTrips! شركتي سعيدة، وأستطيع رؤية عائلتي أكثر. وضع مربح للجانبين!"
    }
  },
  {
    id: 16,
    name: "Layla Al-Jabri",
    location: "Nizwa, Oman",
    image: "https://i.pravatar.cc/150?img=46",
    rating: 5,
    text: {
      en: "Girls' trip to Turkey was amazing! We paid only 58 OMR each from Muscat to Istanbul. Shopping, food, history - all within budget. NuzhaTrips made us feel like travel queens! 👑✨",
      ar: "رحلة البنات إلى تركيا كانت رائعة! دفعنا 58 ريال فقط لكل واحدة من مسقط إلى إسطنبول. تسوق، طعام، تاريخ - كل شيء ضمن الميزانية. جعلتنا NuzhaTrips نشعر كملكات السفر! 👑✨"
    }
  }
];

export const mockPricingPlans = [
  {
    id: "free",
    name: { en: "Free Plan", ar: "الخطة المجانية" },
    description: { en: "Get started with basic features", ar: "ابدأ مع الميزات الأساسية" },
    price: "0",
    period: { en: "/month", ar: "/شهر" },
    features: [
      { text: { en: "Monthly flight deal alerts", ar: "تنبيهات شهرية بصفقات الطيران" }, included: true },
      { text: { en: "Email support", ar: "دعم عبر البريد الإلكتروني" }, included: true },
      { text: { en: "Access to private deals", ar: "الوصول إلى الصفقات الخاصة" }, included: false },
      { text: { en: "Priority WhatsApp support", ar: "دعم واتساب مميز" }, included: false },
      { text: { en: "Exclusive member discounts", ar: "خصومات حصرية للأعضاء" }, included: false }
    ],
    popular: false
  },
  {
    id: "premium",
    name: { en: "Premium Plan (Yearly)", ar: "الخطة المميزة (سنوي)" },
    description: { en: "Best value for frequent travelers", ar: "أفضل قيمة للمسافرين الدائمين" },
    price: "35",
    period: { en: "/year", ar: "/سنوياً" },
    features: [
      { text: { en: "Weekly flight deal alerts", ar: "تنبيهات أسبوعية بصفقات الطيران" }, included: true },
      { text: { en: "Access to private deals", ar: "الوصول إلى الصفقات الخاصة" }, included: true },
      { text: { en: "Priority WhatsApp support", ar: "دعم واتساب مميز" }, included: true },
      { text: { en: "Exclusive member discounts", ar: "خصومات حصرية للأعضاء" }, included: true },
      { text: { en: "Early access to flash sales", ar: "وصول مبكر للعروض السريعة" }, included: true }
    ],
    popular: true
  }
];

export const popularRoutes = [
  {
    id: 1,
    from: "Muscat",
    to: "Salalah, Oman",
    fare: "35 - 45",
    currency: "OMR",
    airlines: "SalamAir, Oman Air",
    reason: {
      en: "The Khareef season (monsoon) transforms the desert into lush greenery, but it is a perfect winter escape for beaches.",
      ar: "موسم الخريف (الرياح الموسمية) يحول الصحراء إلى خضرة، وهو أيضاً ملاذ شتوي مثالي للشواطئ."
    },
    image: "https://customer-assets.emergentagent.com/job_nozhatrips/artifacts/li8ictv7_1765179782824-019afcea-bced-777d-92d3-778057afa699.png",
    icon: "💚"
  },
  {
    id: 2,
    from: "Muscat",
    to: "Mumbai, India",
    fare: "50 - 60",
    currency: "OMR",
    airlines: "Air India Express, IndiGo, Oman Air",
    reason: {
      en: "A short 3-hour hop for business, Bollywood tours, and incredible street food.",
      ar: "رحلة قصيرة 3 ساعات للأعمال وجولات بوليوود وطعام الشارع الرائع."
    },
    image: "https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=500&q=80",
    icon: "🏙️"
  },
  {
    id: 3,
    from: "Muscat",
    to: "Istanbul, Turkey",
    fare: "55 - 65",
    currency: "OMR",
    airlines: "Pegasus Airlines, SalamAir",
    reason: {
      en: "A budget-friendly favorite for history, shopping, and crossing the Bosphorus between Europe and Asia.",
      ar: "الخيار المفضل الاقتصادي للتاريخ والتسوق وعبور البوسفور بين أوروبا وآسيا."
    },
    image: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=500&q=80",
    icon: "🕌"
  },
  {
    id: 4,
    from: "Muscat",
    to: "Dubai, UAE",
    fare: "55 - 70",
    currency: "OMR",
    airlines: "SalamAir, flydubai",
    reason: {
      en: "The ultimate weekend shopping and entertainment destination, less than an hour away by air.",
      ar: "وجهة نهاية الأسبوع المثالية للتسوق والترفيه، على بعد أقل من ساعة بالطائرة."
    },
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=500&q=80",
    icon: "🏙️"
  },
  {
    id: 5,
    from: "Muscat",
    to: "Cairo, Egypt",
    fare: "75 - 90",
    currency: "OMR",
    airlines: "Air Arabia, Nile Air",
    reason: {
      en: "The gateway to ancient history, pyramids, and the Nile river.",
      ar: "بوابة التاريخ القديم والأهرامات ونهر النيل."
    },
    image: "https://images.unsplash.com/photo-1572252009286-268acec5ca0a?w=500&q=80",
    icon: "🔺"
  },
  {
    id: 6,
    from: "Muscat",
    to: "Bangkok, Thailand",
    fare: "105 - 125",
    currency: "OMR",
    airlines: "Air Arabia (via Sharjah), SalamAir",
    reason: {
      en: "The top destination for street food, nightlife, and access to tropical islands.",
      ar: "الوجهة الأولى لطعام الشارع والحياة الليلية والوصول إلى الجزر الاستوائية."
    },
    image: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=500&q=80",
    icon: "🏖️"
  },
  {
    id: 7,
    from: "Muscat",
    to: "London, UK",
    fare: "220 - 250",
    currency: "OMR",
    airlines: "Pegasus (via Istanbul), Wizz Air (via Abu Dhabi), Oman Air",
    reason: {
      en: "A major hub for Omani students and summer tourists seeking cooler weather.",
      ar: "مركز رئيسي للطلاب العمانيين والسياح الصيفيين الباحثين عن طقس أبرد."
    },
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=500&q=80",
    icon: "🏰"
  },
  {
    id: 8,
    from: "Muscat",
    to: "Kuala Lumpur, Malaysia",
    fare: "230 - 250",
    currency: "OMR",
    airlines: "Air Arabia, Batik Air",
    reason: {
      en: "A lush, green city famous for the Petronas Towers and multicultural cuisine.",
      ar: "مدينة خضراء مورقة مشهورة بأبراج بتروناس والمأكولات متعددة الثقافات."
    },
    image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=500&q=80",
    icon: "🏢"
  }
];

// Mock API functions
export const mockNewsletterSignup = async (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock newsletter signup:', email);
      resolve({ success: true, message: 'Successfully subscribed to newsletter!' });
    }, 1000);
  });
};

export const mockContactSubmit = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock contact form submission:', formData);
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};

export const mockSubscriptionSubmit = async (subscriptionData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock subscription:', subscriptionData);
      resolve({ 
        success: true, 
        message: 'Subscription initiated! Redirecting to payment...', 
        subscriptionId: 'mock-' + Date.now() 
      });
    }, 1000);
  });
};
